import { JepGraphic } from '@jeppesen-foreflight/jmkw-types';
import * as stringUtils from '../../../../utilities/string-format.utils';
import { NavigationFeatureType } from '../navigation-feature-type';
import { FeatureDetail } from './feature-detail';
import { WaypointAttributesRaw } from './waypoint-attributes-raw';
import { WaypointAttributes } from './waypoint-attributes';

export class Waypoint implements FeatureDetail {
  id: string;
  navType: NavigationFeatureType = 'waypoint';
  attributes: WaypointAttributes;

  constructor(public graphic: JepGraphic) {
    this.attributes = this._formatAttributes(graphic?.attributes);
    this.id = this._getId(graphic?.attributes);
  }

  private _getId(attrs?: WaypointAttributesRaw): string {
    return stringUtils.formatString(attrs?.name);
  }

  private _formatAttributes(attrs?: WaypointAttributesRaw): WaypointAttributes {
    if (!attrs) {
      return {
        function: '',
        coordinates: '',
        sourcelatitudedd: '',
        sourcelongitudedd: '',
        id: '',
        magneticVariation: stringUtils.formatMagneticVariation(0),
        minCrossingAlt: '',
        minReceptionAlt: '',
        name: '',
        namedCode: 0,
        type: '',
        usage: ''
      };
    }

    return {
      function: stringUtils.formatString(attrs.function),
      coordinates: stringUtils.formatLatLong(attrs.latitude, attrs.longitude),
      sourcelatitudedd: attrs.sourcelatitudedd ?? '',
      sourcelongitudedd: attrs.sourcelongitudedd ?? '',
      id: stringUtils.formatString(attrs.identifier),
      magneticVariation: stringUtils.formatMagneticVariation(
        attrs.magneticvariation
      ),
      minCrossingAlt: stringUtils.formatAltitude(attrs.mca),
      minReceptionAlt: stringUtils.formatAltitude(attrs.mra_altitude),
      name: stringUtils.formatString(attrs.name),
      namedCode: attrs.namedcode ?? 0,
      type: stringUtils.formatString(attrs.type),
      usage: stringUtils.formatString(attrs.usage)
    };
  }
}
